import { Actions, Button, Notice, Stack, Text } from 'braid-design-system';

import { NameField } from '../NameField/NameField.tsx';

interface Props {
  error: string | undefined;
  loading: boolean;
  onExit: () => void;
  dataType: 'live' | 'publicTest';
}

export const NewCredentialForm = ({
  error,
  loading,
  onExit,
  dataType,
}: Props) => (
  <Stack space="large">
    <NameField
      disabled={loading}
      id="new-credential-name-field"
      showLabel
      dataType={dataType}
    />

    <Actions>
      <Button loading={loading} tone="brandAccent" type="submit">
        {loading ? 'Creating' : 'Create'}
      </Button>

      <Button onClick={onExit} variant="transparent">
        Cancel
      </Button>
    </Actions>

    {error ? (
      <Notice tone="critical">
        <Stack space="medium">
          <Text>We couldn’t create your credentials.</Text>

          <Text>{error}</Text>
        </Stack>
      </Notice>
    ) : null}
  </Stack>
);
